import React, { PureComponent } from "react";
import "./index.css";
import { Button } from "reactstrap";
import LoadMore from "../../components/LoadMore";

class Logs extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div className="log-container">
        <div className="log-title">Logs</div>
        <hr className="hr-logs-contain" />
        <div className="logs-body">
          <div className="logs-date">15 Gusht 2019</div>

          <div className="logs-details">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </div>
          <div className="logs-number">No. 66 of 2019</div>
          <div className=" log-button">
            <Button color="secondary" size={"sm"}>
              Me shume
            </Button>
          </div>
        </div>

        <div className="logs-body">
          <div className="logs-date">15 Gusht 2019</div>

          <div className="logs-details">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </div>
          <div className="logs-number">No. 66 of 2019</div>
          <div className="log-button ">
            <Button color="secondary" size={"sm"}>
              Me shume
            </Button>
          </div>
        </div>

        <div className="logs-body">
          <div className="logs-date">15 Gusht 2019</div>

          <div className="logs-details">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </div>
          <div className="logs-number">No. 66 of 2019</div>
          <div className=" log-button">
            <Button color="secondary" size={"sm"}>
              Me shume
            </Button>
          </div>
        </div>

        <div className="logs-body">
          <div className="logs-date">15 Gusht 2019</div>

          <div className="logs-details">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </div>
          <div className="logs-number">No. 66 of 2019</div>
          <div className=" log-button">
            <Button color="secondary" size={"sm"}>
              Me shume
            </Button>
          </div>
        </div>

        <div className="more-logs">
          <LoadMore />
        </div>
      </div>
    );
  }
}

Logs.propTypes = {};

export default Logs;
